module.exports = __webpack_public_path__ + "img/symbol_7.484f2286.png";